/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { lazy } from 'react';

import DefaultModal from './DefaultModal';

import Styles from '../../css/modals/PrivacySettingsModal.module.css';
import useLazyComponent from '../../common/hooks/useLazyComponent';
import { CircularProgress } from '@mui/material';

const PrivacySettingsForm = lazy(() => import('../forms/PrivacySettingsForm'));

function PrivacySettingsModal({ borrowerNumber, open, onClose }) {
  const PrivacySettingsFormProps = { borrowerNumber, onClose };
  const PrivacySettingsFormLazy = useLazyComponent(
    PrivacySettingsForm,
    <CircularProgress />,
    `PrivacySettingsForm: ${JSON.stringify(PrivacySettingsFormProps)}`,
  );

  return (
    <DefaultModal open={open} className={Styles.section}>
      <PrivacySettingsFormLazy {...PrivacySettingsFormProps} />
    </DefaultModal>
  );
}

export default PrivacySettingsModal;
